var zh = require('./zh.js')
var bodyFactory = require('./bodyFactory.js')
var searchIndex = require('./searchIndex.js')
var searchTermBankEn = require('./searchTermBankEn.js')
var brandContent = require('./brandContent.js')
var modelReviewLocales = require('./modelReviewLocales.js')
var ctaLabels = require('./ctaLabels.js')

var FREE_TRIAL_TEMPLATES = {
  zh: '免费试用 {name}',
  en: 'Try {name} for Free',
  ja: '{name}を無料で試す',
  ko: '{name} 무료 체험',
  fr: 'Essayer {name} gratuitement',
  es: 'Probar {name} gratis',
  it: 'Prova {name} gratis',
  de: '{name} kostenlos testen',
  pt: 'Testar {name} grátis',
  pl: 'Wypróbuj {name} za darmo',
  ar: 'جرّب {name} مجانًا'
}

var COMMON_TEXT_OVERRIDES = {
  en: {},
  ja: {
    mainFeatureTitle: 'Miral AIを無料で試す',
    mainFeatureLinksTitle: 'Miralの人気機能',
    searchResultPrefix: '「',
    searchResultMiddle: '」の検索結果: ',
    searchResultSuffix: ' 件',
    noResultsPrefix: '「',
    noResultsSuffix: '」に一致する記事はありません。',
    paginationLabel: 'ブログのページ送り',
    metaTitleCategorySuffix: ' - AI画像生成ブログ | Miral',
    expandPrefix: '展開: ',
    quickAnchorLabel: '記事内クイックリンク',
    notFoundMetaTitle: '記事が見つかりません | Miral',
    defaultStepTitle: '基本の使い方',
    alternativesStepTitle: 'モデルを比べる流れ',
    howToStepTitle: '操作手順',
    promptStepTitle: 'プロンプト作成の流れ',
    reviewStepTitle: 'レビュー時の確認手順',
    editorNoteTool: '処理したい画像がすでにある場合は、適用シーンと手順を確認してから、その画像に合うツールを開いてください。',
    editorNoteGuide: 'この記事は実際の使用感に基づくガイドです。まず要約を確認し、例と手順を見てからMiralで試してください。',
    editorNoteDefault: '適用シーンと手順を確認してから、対応するMiral機能で試してください。',
    comparePills: ['アート探索', '商用ビジュアル', '文字入りポスター', 'ブラウザで利用'],
    workflowSteps: ['文書補正', '手書き消去', '透かし除去', '保存 / OCR'],
    docSearchAliasLinks: [
      { label: '画像の切り抜き補正', path: '/tools/doc-crop-enhance' },
      { label: '文書補正', path: '/tools/doc-crop-enhance' },
      { label: '手書き消去', path: '/tools/handwritten-erase' },
      { label: 'AI透かし除去', path: '/tools/watermark-remover' }
    ]
  },
  ko: {
    mainFeatureTitle: 'Miral AI 무료 체험',
    mainFeatureLinksTitle: '인기 Miral 기능',
    searchResultPrefix: '"',
    searchResultMiddle: '" 검색 결과 ',
    searchResultSuffix: '개',
    noResultsPrefix: '"',
    noResultsSuffix: '"에 맞는 글이 없습니다.',
    paginationLabel: '블로그 페이지 이동',
    metaTitleCategorySuffix: ' - AI 이미지 생성 블로그 | Miral',
    expandPrefix: '펼치기 ',
    quickAnchorLabel: '글 빠른 이동',
    notFoundMetaTitle: '글을 찾을 수 없음 | Miral',
    defaultStepTitle: '기본 사용 흐름',
    alternativesStepTitle: '모델을 비교하는 흐름',
    howToStepTitle: '작업 단계',
    promptStepTitle: '프롬프트 작성 흐름',
    reviewStepTitle: '리뷰 확인 흐름',
    editorNoteTool: '처리할 이미지가 이미 있다면 적용 상황과 단계를 먼저 확인한 뒤 이미지 문제에 맞는 도구를 여세요.',
    editorNoteGuide: '이 글은 실제 사용 경험을 바탕으로 한 가이드입니다. 요약을 먼저 보고 예시와 단계를 확인한 뒤 Miral에서 테스트하세요.',
    editorNoteDefault: '적용 상황과 단계를 확인한 뒤 해당 Miral 기능에서 테스트하세요.',
    comparePills: ['아트 탐색', '상업용 결과', '텍스트 포스터', '브라우저 사용'],
    workflowSteps: ['문서 보정', '손글씨 제거', '워터마크 제거', '보관 / OCR'],
    docSearchAliasLinks: [
      { label: '이미지 자르기 보정', path: '/tools/doc-crop-enhance' },
      { label: '문서 보정', path: '/tools/doc-crop-enhance' },
      { label: '손글씨 제거', path: '/tools/handwritten-erase' },
      { label: 'AI 워터마크 제거', path: '/tools/watermark-remover' }
    ]
  },
  fr: {
    mainFeatureTitle: 'Essayez Miral AI gratuitement',
    mainFeatureLinksTitle: 'Fonctions Miral populaires',
    categoryNavLabel: 'Catégories du blog',
    searchPlaceholder: 'Rechercher modèles, outils, prompts ou scénarios, par exemple images ecommerce Seedream',
    searchResultPrefix: 'Résultats pour « ',
    searchResultMiddle: ' » : ',
    searchResultSuffix: ' articles',
    noResultsPrefix: 'Aucun article trouvé pour « ',
    noResultsSuffix: ' ».',
    paginationLabel: 'Pagination du blog',
    defaultDescription: 'Guides sur les générateurs d’images IA, outils image, avis de modèles, alternatives et workflows de prompts.',
    metaTitleCategorySuffix: ' - Blog de génération d’images IA | Miral',
    inArticleLabel: 'Dans cet article',
    quickAnchorLabel: 'Liens rapides de l’article',
    notFoundMetaTitle: 'Article introuvable | Miral',
    defaultStepTitle: 'Workflow conseillé',
    alternativesStepTitle: 'Comment je compare les modèles',
    howToStepTitle: 'Étapes',
    promptStepTitle: 'Méthode de prompt',
    reviewStepTitle: 'Méthode de test',
    editorNoteTool: 'Si vous avez déjà une image à traiter, vérifiez les cas d’usage et les étapes, puis ouvrez l’outil adapté au problème.',
    editorNoteGuide: 'Ce guide repose sur une utilisation pratique. Lisez d’abord le résumé, puis comparez les exemples et les étapes avant d’essayer Miral.',
    editorNoteDefault: 'Vérifiez les cas d’usage et les étapes, puis essayez la fonction Miral correspondante.',
    comparePills: ['Exploration artistique', 'Visuels commerciaux', 'Affiches avec texte', 'Dans le navigateur'],
    workflowSteps: ['Correction document', 'Effacement manuscrit', 'Suppression filigrane', 'Archive / OCR'],
    docSearchAliasLinks: [
      { label: 'Recadrage et redressement', path: '/tools/doc-crop-enhance' },
      { label: 'Correction de document', path: '/tools/doc-crop-enhance' },
      { label: 'Effacement manuscrit', path: '/tools/handwritten-erase' },
      { label: 'Suppression de filigrane IA', path: '/tools/watermark-remover' }
    ]
  },
  es: {
    mainFeatureTitle: 'Prueba Miral AI gratis',
    mainFeatureLinksTitle: 'Funciones populares de Miral',
    categoryNavLabel: 'Categorías del blog',
    searchPlaceholder: 'Busca modelos, herramientas, prompts o escenarios, por ejemplo imágenes ecommerce con Seedream',
    searchResultPrefix: 'Resultados para "',
    searchResultMiddle: '": ',
    searchResultSuffix: ' artículos',
    noResultsPrefix: 'No se encontraron artículos para "',
    noResultsSuffix: '".',
    paginationLabel: 'Paginación del blog',
    defaultDescription: 'Guías de generadores de imágenes IA, herramientas, reseñas, alternativas y flujos de prompts.',
    metaTitleCategorySuffix: ' - Blog de generación de imágenes IA | Miral',
    inArticleLabel: 'En este artículo',
    quickAnchorLabel: 'Enlaces rápidos del artículo',
    notFoundMetaTitle: 'Artículo no encontrado | Miral',
    defaultStepTitle: 'Flujo recomendado',
    alternativesStepTitle: 'Cómo comparo los modelos',
    howToStepTitle: 'Pasos',
    promptStepTitle: 'Flujo de prompt',
    reviewStepTitle: 'Flujo de prueba',
    editorNoteTool: 'Si ya tienes una imagen para procesar, revisa los casos de uso y los pasos antes de abrir la herramienta adecuada.',
    editorNoteGuide: 'Esta guía se basa en uso práctico. Revisa primero el resumen, luego los ejemplos y pasos, y prueba en Miral.',
    editorNoteDefault: 'Revisa los casos de uso y los pasos, y luego prueba la función correspondiente de Miral.',
    comparePills: ['Exploración artística', 'Visuales comerciales', 'Pósteres con texto', 'En el navegador'],
    workflowSteps: ['Corrección de documentos', 'Borrado de escritura', 'Quitar marca de agua', 'Archivo / OCR'],
    docSearchAliasLinks: [
      { label: 'Recorte y corrección', path: '/tools/doc-crop-enhance' },
      { label: 'Corrección de documentos', path: '/tools/doc-crop-enhance' },
      { label: 'Borrador de escritura', path: '/tools/handwritten-erase' },
      { label: 'Quitar marca de agua IA', path: '/tools/watermark-remover' }
    ]
  },
  it: {
    mainFeatureTitle: 'Prova Miral AI gratis',
    mainFeatureLinksTitle: 'Funzioni Miral più usate',
    categoryNavLabel: 'Categorie del blog',
    searchPlaceholder: 'Cerca modelli, strumenti, prompt o scenari, ad esempio immagini ecommerce Seedream',
    searchResultPrefix: 'Risultati per "',
    searchResultMiddle: '": ',
    searchResultSuffix: ' articoli',
    noResultsPrefix: 'Nessun articolo trovato per "',
    noResultsSuffix: '".',
    paginationLabel: 'Paginazione blog',
    defaultDescription: 'Guide per generatori immagini IA, strumenti, recensioni, alternative e workflow prompt.',
    metaTitleCategorySuffix: ' - Blog generazione immagini IA | Miral',
    inArticleLabel: 'In questo articolo',
    quickAnchorLabel: 'Link rapidi dell’articolo',
    notFoundMetaTitle: 'Articolo non trovato | Miral',
    defaultStepTitle: 'Workflow consigliato',
    alternativesStepTitle: 'Come confronto i modelli',
    howToStepTitle: 'Passaggi',
    promptStepTitle: 'Workflow prompt',
    reviewStepTitle: 'Workflow di test',
    editorNoteTool: 'Se hai già un’immagine da elaborare, controlla casi d’uso e passaggi prima di aprire lo strumento adatto.',
    editorNoteGuide: 'Questa guida si basa sull’uso pratico. Leggi prima la sintesi, poi esempi e passaggi, quindi prova in Miral.',
    editorNoteDefault: 'Controlla casi d’uso e passaggi, poi prova la funzione Miral corrispondente.',
    comparePills: ['Esplorazione artistica', 'Visual commerciali', 'Poster con testo', 'Nel browser'],
    workflowSteps: ['Correzione documento', 'Rimozione scrittura', 'Rimozione watermark', 'Archivio / OCR'],
    docSearchAliasLinks: [
      { label: 'Ritaglio e correzione', path: '/tools/doc-crop-enhance' },
      { label: 'Correzione documenti', path: '/tools/doc-crop-enhance' },
      { label: 'Rimozione scrittura', path: '/tools/handwritten-erase' },
      { label: 'Rimozione watermark IA', path: '/tools/watermark-remover' }
    ]
  },
  de: {
    mainFeatureTitle: 'Miral AI kostenlos testen',
    mainFeatureLinksTitle: 'Beliebte Miral-Funktionen',
    categoryNavLabel: 'Blog-Kategorien',
    searchPlaceholder: 'Modelle, Tools, Prompts oder Szenarien suchen, z. B. Seedream Ecommerce-Bilder',
    searchResultPrefix: 'Ergebnisse für „',
    searchResultMiddle: '“: ',
    searchResultSuffix: ' Artikel',
    noResultsPrefix: 'Keine Artikel gefunden für „',
    noResultsSuffix: '“.',
    paginationLabel: 'Blog-Paginierung',
    defaultDescription: 'Guides zu KI-Bildgeneratoren, Bildtools, Modellreviews, Alternativen und Prompt-Workflows.',
    metaTitleCategorySuffix: ' - KI-Bildgenerierung Blog | Miral',
    inArticleLabel: 'In diesem Artikel',
    quickAnchorLabel: 'Schnelllinks im Artikel',
    notFoundMetaTitle: 'Artikel nicht gefunden | Miral',
    defaultStepTitle: 'Empfohlener Ablauf',
    alternativesStepTitle: 'So vergleiche ich Modelle',
    howToStepTitle: 'Schritte',
    promptStepTitle: 'Prompt-Ablauf',
    reviewStepTitle: 'Testablauf',
    editorNoteTool: 'Wenn du bereits ein Bild bearbeiten möchtest, prüfe zuerst Einsatzzwecke und Schritte und öffne dann das passende Tool.',
    editorNoteGuide: 'Dieser Guide basiert auf praktischer Nutzung. Lies zuerst das Kurzfazit, dann Beispiele und Schritte, und teste in Miral.',
    editorNoteDefault: 'Prüfe Einsatzzwecke und Schritte und teste dann die passende Miral-Funktion.',
    comparePills: ['Kunst-Exploration', 'Kommerzielle Visuals', 'Poster mit Text', 'Im Browser'],
    workflowSteps: ['Dokumentkorrektur', 'Handschrift entfernen', 'Wasserzeichen entfernen', 'Archiv / OCR'],
    docSearchAliasLinks: [
      { label: 'Bild zuschneiden und entzerren', path: '/tools/doc-crop-enhance' },
      { label: 'Dokumentkorrektur', path: '/tools/doc-crop-enhance' },
      { label: 'Handschrift entfernen', path: '/tools/handwritten-erase' },
      { label: 'KI-Wasserzeichen entfernen', path: '/tools/watermark-remover' }
    ]
  },
  pt: {
    mainFeatureTitle: 'Experimente o Miral AI grátis',
    mainFeatureLinksTitle: 'Recursos populares do Miral',
    categoryNavLabel: 'Categorias do blog',
    searchPlaceholder: 'Busque modelos, ferramentas, prompts ou cenários, por exemplo imagens ecommerce Seedream',
    searchResultPrefix: 'Resultados para "',
    searchResultMiddle: '": ',
    searchResultSuffix: ' artigos',
    noResultsPrefix: 'Nenhum artigo encontrado para "',
    noResultsSuffix: '".',
    paginationLabel: 'Paginação do blog',
    defaultDescription: 'Guias de geradores de imagens IA, ferramentas, avaliações, alternativas e fluxos de prompts.',
    metaTitleCategorySuffix: ' - Blog de geração de imagens IA | Miral',
    inArticleLabel: 'Neste artigo',
    quickAnchorLabel: 'Links rápidos do artigo',
    notFoundMetaTitle: 'Artigo não encontrado | Miral',
    defaultStepTitle: 'Fluxo recomendado',
    alternativesStepTitle: 'Como eu comparo os modelos',
    howToStepTitle: 'Passos',
    promptStepTitle: 'Fluxo de prompt',
    reviewStepTitle: 'Fluxo de teste',
    editorNoteTool: 'Se você já tem uma imagem para processar, confira os casos de uso e os passos antes de abrir a ferramenta adequada.',
    editorNoteGuide: 'Este guia se baseia em uso prático. Leia primeiro o resumo, depois exemplos e passos, e teste no Miral.',
    editorNoteDefault: 'Confira os casos de uso e os passos, depois teste a função Miral correspondente.',
    comparePills: ['Exploração artística', 'Visuais comerciais', 'Pôsteres com texto', 'No navegador'],
    workflowSteps: ['Correção de documento', 'Remover escrita', 'Remover marca d’água', 'Arquivo / OCR'],
    docSearchAliasLinks: [
      { label: 'Recorte e correção', path: '/tools/doc-crop-enhance' },
      { label: 'Correção de documentos', path: '/tools/doc-crop-enhance' },
      { label: 'Remover escrita', path: '/tools/handwritten-erase' },
      { label: 'Remover marca d’água IA', path: '/tools/watermark-remover' }
    ]
  },
  pl: {
    mainFeatureTitle: 'Wypróbuj Miral AI za darmo',
    mainFeatureLinksTitle: 'Popularne funkcje Miral',
    categoryNavLabel: 'Kategorie bloga',
    searchPlaceholder: 'Szukaj modeli, narzędzi, promptów lub scenariuszy, np. obrazy ecommerce Seedream',
    searchResultPrefix: 'Wyniki dla „',
    searchResultMiddle: '”: ',
    searchResultSuffix: ' artykułów',
    noResultsPrefix: 'Nie znaleziono artykułów dla „',
    noResultsSuffix: '”.',
    paginationLabel: 'Paginacja bloga',
    defaultDescription: 'Poradniki o generatorach obrazów AI, narzędziach, recenzjach, alternatywach i workflow promptów.',
    metaTitleCategorySuffix: ' - Blog generowania obrazów AI | Miral',
    inArticleLabel: 'W tym artykule',
    quickAnchorLabel: 'Szybkie linki artykułu',
    notFoundMetaTitle: 'Nie znaleziono artykułu | Miral',
    defaultStepTitle: 'Zalecany workflow',
    alternativesStepTitle: 'Jak porównuję modele',
    howToStepTitle: 'Kroki',
    promptStepTitle: 'Workflow promptu',
    reviewStepTitle: 'Workflow testu',
    editorNoteTool: 'Jeśli masz już obraz do przetworzenia, sprawdź zastosowania i kroki, a potem otwórz właściwe narzędzie.',
    editorNoteGuide: 'Ten poradnik opiera się na praktycznym użyciu. Najpierw przeczytaj podsumowanie, potem przykłady i kroki, a następnie przetestuj w Miral.',
    editorNoteDefault: 'Sprawdź zastosowania i kroki, a potem przetestuj odpowiednią funkcję Miral.',
    comparePills: ['Eksploracja artystyczna', 'Wizualizacje komercyjne', 'Plakaty z tekstem', 'W przeglądarce'],
    workflowSteps: ['Korekcja dokumentu', 'Usuwanie pisma', 'Usuwanie znaku wodnego', 'Archiwum / OCR'],
    docSearchAliasLinks: [
      { label: 'Kadrowanie i prostowanie', path: '/tools/doc-crop-enhance' },
      { label: 'Korekcja dokumentów', path: '/tools/doc-crop-enhance' },
      { label: 'Usuwanie pisma', path: '/tools/handwritten-erase' },
      { label: 'Usuwanie znaku wodnego AI', path: '/tools/watermark-remover' }
    ]
  },
  ar: {
    mainFeatureTitle: 'جرّب Miral AI مجانًا',
    mainFeatureLinksTitle: 'ميزات Miral الشائعة',
    categoryNavLabel: 'تصنيفات المدونة',
    searchPlaceholder: 'ابحث عن نماذج أو أدوات أو مطالبات أو سيناريوهات مثل صور Seedream للتجارة الإلكترونية',
    searchResultPrefix: 'نتائج البحث عن "',
    searchResultMiddle: '": ',
    searchResultSuffix: ' مقالات',
    noResultsPrefix: 'لم يتم العثور على مقالات لـ "',
    noResultsSuffix: '".',
    paginationLabel: 'ترقيم صفحات المدونة',
    defaultDescription: 'أدلة لمولدات الصور بالذكاء الاصطناعي والأدوات والمراجعات والبدائل وسير عمل المطالبات.',
    metaTitleCategorySuffix: ' - مدونة توليد الصور بالذكاء الاصطناعي | Miral',
    inArticleLabel: 'في هذا المقال',
    quickAnchorLabel: 'روابط سريعة داخل المقال',
    notFoundMetaTitle: 'المقال غير موجود | Miral',
    defaultStepTitle: 'سير العمل المقترح',
    alternativesStepTitle: 'كيف أقارن النماذج',
    howToStepTitle: 'الخطوات',
    promptStepTitle: 'سير كتابة المطالبة',
    reviewStepTitle: 'سير الاختبار',
    editorNoteTool: 'إذا كانت لديك صورة تريد معالجتها، راجع حالات الاستخدام والخطوات أولًا، ثم افتح الأداة المناسبة للمشكلة.',
    editorNoteGuide: 'يعتمد هذا الدليل على الاستخدام العملي. ابدأ بالخلاصة، ثم راجع الأمثلة والخطوات، وبعدها جرّب في Miral.',
    editorNoteDefault: 'راجع حالات الاستخدام والخطوات، ثم جرّب وظيفة Miral المناسبة.',
    comparePills: ['استكشاف فني', 'مرئيات تجارية', 'ملصقات بنص', 'من المتصفح'],
    workflowSteps: ['تصحيح المستند', 'إزالة الكتابة اليدوية', 'إزالة العلامة المائية', 'أرشفة / OCR'],
    docSearchAliasLinks: [
      { label: 'قص وتصحيح الصور', path: '/tools/doc-crop-enhance' },
      { label: 'تصحيح المستندات', path: '/tools/doc-crop-enhance' },
      { label: 'إزالة الكتابة اليدوية', path: '/tools/handwritten-erase' },
      { label: 'إزالة العلامة المائية بالذكاء الاصطناعي', path: '/tools/watermark-remover' }
    ]
  }
}

var DEFAULT_MODEL_LINKS = [
  { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
  { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
  { label: 'Midjourney', path: '/image-models/midjourney-ai-image-generator' },
  { label: 'GPT Image 1.5', path: '/image-models/gpt-image-ai-image-generator' },
  { label: 'Qwen Image 2.0 Pro', path: '/image-models/qwen-image-2-0-pro-ai-image-generator' },
  { label: 'Z Image Turbo', path: '/image-models/z-image-turbo-ai-image-generator' },
  { label: 'Stable Diffusion 3.5', path: '/image-models/stable-diffusion-ai-image-generator' }
]

var DEFAULT_TOOL_LINKS = [
  { label: 'AI Background Remover', path: '/tools/background-remover' },
  { label: 'AI Image Enhancer', path: '/tools/image-enhancer' },
  { label: 'AI Object Remover', path: '/tools/object-remover' },
  { label: 'AI Watermark Remover', path: '/tools/watermark-remover' },
  { label: 'Handwriting Eraser', path: '/tools/handwritten-erase' },
  { label: 'Document Crop & Dewarp', path: '/tools/doc-crop-enhance' }
]

var LOCALIZED_TOOL_LINK_LABELS = {
  de: ['KI-Hintergrundentferner', 'KI-Bildverbesserung', 'KI-Objektentferner', 'KI-Wasserzeichen entfernen', 'Handschrift entfernen', 'Dokument zuschneiden und entzerren'],
  es: ['Eliminador de fondo IA', 'Mejorador de imágenes IA', 'Eliminador de objetos IA', 'Eliminar marca de agua con IA', 'Borrar escritura a mano', 'Recortar y corregir documentos'],
  fr: ['Suppression d’arrière-plan IA', 'Amélioration d’image IA', 'Suppression d’objets IA', 'Suppression de filigrane IA', 'Effacement manuscrit', 'Recadrage et redressement de documents'],
  it: ['Rimozione sfondo IA', 'Miglioramento immagini IA', 'Rimozione oggetti IA', 'Rimozione watermark IA', 'Rimozione scrittura a mano', 'Ritaglio e correzione documenti'],
  pt: ['Removedor de fundo IA', 'Aprimorador de imagens IA', 'Remover objetos com IA', 'Remover marca d’água com IA', 'Remover escrita à mão', 'Recortar e corrigir documentos'],
  pl: ['Usuwanie tła AI', 'Wyostrzanie obrazów AI', 'Usuwanie obiektów AI', 'Usuwanie znaków wodnych AI', 'Usuwanie pisma odręcznego', 'Kadrowanie i prostowanie dokumentów'],
  ja: ['AI 背景除去', 'AI画像強化', 'AIオブジェクト除去', 'AI透かし除去', '手書き消去', '文書の切り抜き・補正'],
  ko: ['AI 배경 제거', 'AI 이미지 향상', 'AI 오브젝트 제거', 'AI 워터마크 제거', '손글씨 제거', '문서 자르기 및 보정'],
  ar: ['أداة إزالة الخلفية بالذكاء الاصطناعي', 'تحسين الصور بالذكاء الاصطناعي', 'إزالة الكائنات بالذكاء الاصطناعي', 'إزالة العلامة المائية بالذكاء الاصطناعي', 'إزالة الكتابة اليدوية', 'قص المستند وتصحيحه']
}

var DEFAULT_FEATURE_LINKS = DEFAULT_MODEL_LINKS.concat(DEFAULT_TOOL_LINKS)

function getCommonModelLinks(locale) {
  return locale === 'zh' ? zh.COMMON_MODEL_LINKS : DEFAULT_MODEL_LINKS
}

function getCommonToolLinks(locale) {
  var labels
  if (locale === 'zh') return zh.COMMON_TOOL_LINKS
  labels = LOCALIZED_TOOL_LINK_LABELS[locale]
  if (!labels) return DEFAULT_TOOL_LINKS
  return DEFAULT_TOOL_LINKS.map(function (item, index) {
    return { label: labels[index], path: item.path }
  })
}

function getHubFeatureLinks(locale) {
  if (locale === 'zh') return zh.HUB_FEATURE_LINKS
  return getCommonModelLinks(locale).concat(getCommonToolLinks(locale))
}

function buildCategoryMap(categories) {
  return categories.reduce(function (map, item) {
    map[item.key] = item
    return map
  }, {})
}

function getSearchIndexOptions(locale, extraTerms) {
  return {
    locale: locale,
    extraTerms: extraTerms || [],
    includeKeywords: locale === 'zh' || locale === 'en',
    stripCjkForNonZh: locale !== 'zh'
  }
}

function truncateNavTitle(text, maxLen) {
  var limit = maxLen || 40
  var value = String(text || '').trim()
  if (value.length <= limit) return value
  return value.slice(0, limit) + '…'
}

function getStepNavTitle(text, article) {
  if (!article) return text.defaultStepTitle
  if (article.category === 'alternatives') return text.alternativesStepTitle
  if (article.category === 'how-to-guides') return text.howToStepTitle
  if (article.category === 'prompt-guides') return text.promptStepTitle
  return text.reviewStepTitle
}

function buildSectionNavChildren(section, article, text) {
  var children = []
  var blocks = section.blocks || []
  var i
  for (i = 0; i < blocks.length; i++) {
    if (blocks[i].type === 'steps') {
      children.push({
        id: section.id + '-steps',
        anchor: section.id + '-steps',
        title: getStepNavTitle(text, article)
      })
    }
  }
  if (section.id === 'faq') {
    for (i = 0; i < blocks.length; i++) {
      if (blocks[i].type === 'faq-item') {
        children.push({
          id: section.id + '-q-' + i,
          anchor: section.id + '-q-' + i,
          title: truncateNavTitle(blocks[i].question)
        })
      }
    }
    return children
  }
  if (section.id === 'prompt-examples') {
    for (i = 0; i < blocks.length; i++) {
      if (blocks[i].type === 'prompt-example') {
        children.push({
          id: section.id + '-p-' + i,
          anchor: section.id + '-p-' + i,
          title: truncateNavTitle(blocks[i].label || text.promptExample, 28)
        })
      }
    }
  }
  return children
}

function buildArticleNavTree(article, text) {
  if (!article) return []
  var sections = article.sections || []
  var tree = []
  var i
  for (i = 0; i < sections.length; i++) {
    var section = sections[i]
    tree.push({
      id: section.id,
      title: section.title,
      children: buildSectionNavChildren(section, article, text)
    })
  }
  return tree
}

function buildArticle(article, override, locale) {
  override = override || {}
  var out = Object.assign({}, article, override)
  delete out.readTime
  if (override.title && !override.metaTitle) {
    out.metaTitle = override.title + ' | Miral'
  }
  if (override.excerpt && !override.metaDescription) {
    out.metaDescription = override.excerpt
  }
  if (override.target) {
    out.target = Object.assign({}, article.target || {}, override.target)
  }
  if (locale !== 'zh') {
    out.keywords = override.keywords || []
  }
  if (locale === 'en' && (!override.keywords || !override.keywords.length)) {
    var enCore = searchTermBankEn.CORE_KEYWORDS_EN[out.slug]
    if (enCore && enCore.length) {
      out.keywords = enCore.slice()
    }
  }
  var generated = bodyFactory.buildArticleContent(locale, out)
  if (generated) {
    out = Object.assign({}, out, generated, override || {})
    if (override.target) {
      out.target = Object.assign({}, article.target || {}, override.target)
    }
    if (locale !== 'zh') {
      out.keywords = override.keywords || []
    }
    if (locale === 'en' && (!override.keywords || !override.keywords.length)) {
      var enCoreAfter = searchTermBankEn.CORE_KEYWORDS_EN[out.slug]
      if (enCoreAfter && enCoreAfter.length) {
        out.keywords = enCoreAfter.slice()
      }
    }
  }
  var extraTerms = override.searchTerms || []
  if (locale === 'en') {
    extraTerms = extraTerms.concat(searchTermBankEn.TERM_BANK[out.slug] || [])
  }
  out = brandContent.decorateArticleBrandContent(out, locale)
  out = ctaLabels.applyFreeTrialTarget(
    out,
    locale,
    FREE_TRIAL_TEMPLATES[locale] || FREE_TRIAL_TEMPLATES.en
  )
  return searchIndex.attachArticleSearchFields(out, getSearchIndexOptions(locale, extraTerms))
}

function buildArticles(locale, overrides) {
  var map = Object.assign({}, modelReviewLocales.getModelReviewArticles(locale), overrides || {})
  return zh.HUB_ARTICLES.filter(function (article) {
    return !article.supportedLocales || article.supportedLocales.indexOf(locale) >= 0
  }).map(function (article) {
    return buildArticle(article, map[article.slug], locale)
  })
}

function buildArticleMap(articles) {
  return articles.reduce(function (map, article) {
    map[article.slug] = article
    return map
  }, {})
}

function createHubLocale(options) {
  options = options || {}
  var locale = options.locale || 'zh'
  if (options.articleBodies) {
    require('./articleBodies.js').registerArticleBodies(locale, options.articleBodies)
  }
  var categories = options.categories || zh.HUB_CATEGORIES
  var categoryMap = buildCategoryMap(categories)
  var text = Object.assign({}, zh.HUB_TEXT, COMMON_TEXT_OVERRIDES[locale] || {}, {
    tryForFreeTemplate: FREE_TRIAL_TEMPLATES[locale] || FREE_TRIAL_TEMPLATES.en
  }, options.text || {})
  var articles = buildArticles(locale, options.articles)
  var articleMap = buildArticleMap(articles)

  return Object.assign({}, zh, {
    HUB_CATEGORIES: categories,
    HUB_TEXT: text,
    HUB_ARTICLES: articles,
    COMMON_MODEL_LINKS: getCommonModelLinks(locale),
    COMMON_TOOL_LINKS: getCommonToolLinks(locale),
    HUB_FEATURE_LINKS: getHubFeatureLinks(locale),
    getHubCategories: function () {
      return categories
    },
    getHubArticles: function (category) {
      if (!category || category === 'all') return articles
      return articles.filter(function (article) {
        return article.category === category
      })
    },
    getHubArticle: function (slug) {
      return articleMap[slug] || null
    },
    getHubCategory: function (key) {
      return categoryMap[key] || null
    },
    getRelatedArticles: function (article) {
      if (!article || !article.related) return []
      return article.related.map(function (slug) {
        return articleMap[slug]
      }).filter(Boolean)
    },
    getHubFeaturedArticles: function (category) {
      if (category && category !== 'all') {
        return this.getHubArticles(category).slice(0, 5)
      }
      return zh.getHubFeaturedArticles('all').map(function (article) {
        return articleMap[article.slug]
      }).filter(Boolean)
    },
    searchHubArticles: function (query, category) {
      var list = this.getHubArticles(category || 'all')
      var options = getSearchIndexOptions(locale)
      if (!searchIndex.normalizeSearchQuery(query)) return list
      return list.filter(function (article) {
        return searchIndex.articleMatchesQuery(article, query, options)
      })
    },
    getHubSearchSuggestions: function (limit, category) {
      return searchIndex.buildSearchSuggestions(
        this.getHubArticles(category || 'all'),
        limit,
        getSearchIndexOptions(locale)
      )
    },
    buildArticleNavTree: function (article) {
      return buildArticleNavTree(article, text)
    }
  })
}

module.exports = createHubLocale
